<template>
  <modal v-model="show" size="lg" :header="false">
    <div class="row" v-if="focus.video && show">
      <div class="col-xs-12">
        <video-frame :link="focus.video.link" :size="focus.video.size"
                     :time="marker" class="video-frame">
        </video-frame>
      </div>
      <div v-if="hasSummary" class="col-xs-12">
        <div class="summary">
          <div class="summary-body">
            <h4 v-if="focus.video.news.length > 0">Sommaire</h4>
            <ul>
              <li v-for="(s, j) in focus.video.news"
                  :key="`news-${j}`">
                <a target="_blank"
                   role="button"
                   @click="marker = s.marker"
                   v-html="s.subject">
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <template slot="footer">
      <div v-if="focus.video">
        <a target="_blank"
           v-if="focus.doc"
           :class="`btn btn-${focus.video.type} btn-lg`"
           :href="`https://cloud.spiadi.fr/s/QfamTBdy4gyCRgz/download?files=${focus.doc}.pdf`">
          Télécharger la présentation
        </a>
        <a target="_blank"
           v-if="focus.video.download"
           :class="`btn btn-${focus.video.type} btn-lg`"
           :href="focus.video.download">
          Télécharger la vidéo
        </a>
        <btn class="default" size="lg" @click="closeVideo">
          Quitter
        </btn>
      </div>
    </template>
  </modal>
</template>

<script>
import videoFrame from '@/components/videoFrame'

export default {
  name: 'video-display',

  props: {
    value: {
      type: Boolean,
      required: true
    },

    source: {
      type: Object
    }
  },

  data: function () {
    return {
      marker: 0,
      show: this.value
    }
  },

  methods: {
    closeVideo: function () {
      this.show = false
      this.marker = 0
    }
  },

  watch: {
    value: function (v) {
      if (v !== this.show) {
        this.show = v
      }
    },

    show: function (v) {
      if (v !== this.value) {
        this.$emit('input', v)
      }
    }
  },

  computed: {
    hasSummary: function () {
      return this.focus.video.news != null
    },

    focus: function () {
      if (this.source == null) {
        return { video: null, doc: null }
      }

      const { date, title } = this.source
      let doc = null
      if (date != null && title != null) {
        const dates = date.split('/')
        const year = dates[2]
        if (parseInt(year) >= 2023) {
          const actu = `${dates[0]}-${dates[1]}-${year}`
          const docTitle = title.join(' ').replaceAll(/<[^>]*>/g, '')
          doc = `SPIADI${year} - Actu SPIADI ${actu} - ${docTitle}`
        }
      }

      return {
        video: this.source,
        doc: doc
      }
    }
  },

  components: {
    videoFrame
  }
}

</script>

<style lang="less" scoped>
@import '~variables';

.video-frame {
  border-radius: 0.4rem;
  overflow: hidden;
  border-top-left-radius: 0rem;
  border-bottom-left-radius: 0rem;
}

.summary {
  position: relative;
  .summary-body {
    padding: 0rem 2rem;

    @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {
    }

    @media (min-width: @screen-lg-min) {
    }

    li {
      list-style: circle;
      margin-bottom: 0.8rem;
    }

    ul {
      padding-left: 2rem;
    }
  }
}

</style>
